import BGLoading from './BGLoading';

let $vm;
let watcher;
let delayTime = null;

const mergeOptions = function ($vm, options) {
  const defaults = {};

  for (let i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default;
    }
  }

  const _options = Object.assign({}, defaults, options);

  for (let i in _options) {
    $vm[i] = _options[i];
  }
};

const plugin = {
  install (vue, options) {
    const Loading = vue.extend(BGLoading);

    if (!$vm) {
      $vm = new Loading({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el)
    }

    const loading = {
      show (options = {}) {
        // destroy watcher
        watcher && watcher();
        if (typeof options === 'string') {
          $vm.text = options
        } else if (typeof options === 'object') {
          mergeOptions($vm, options);
        }
        if (typeof options === 'object' && options.onShow || options.onHide) {
          watcher = $vm.$watch('show', (val) => {
            val && options.onShow && options.onShow($vm);
            val === false && options.onHide && options.onHide($vm)
          });
        }
        delayTime && clearTimeout(delayTime);
        delayTime = setTimeout(() => {
          $vm.show = true;
          // 启动svga动画
          $vm.svgaPlayer.startAnimation();
        }, options.delay || 0);
      },

      hide () {
        if (delayTime) {
          clearTimeout(delayTime);
          delayTime = null;
        }
        $vm.show = false;
        // 暂停svga动画
        $vm.svgaPlayer.pauseAnimation();
      },
      isVisible () {
        return $vm.show;
      },
    };

    // all Vux's plugins are included in this.$vux
    if (!vue.$vux) {
      vue.$vux = {
        loading,
      };
    } else {
      vue.$vux.loading = loading;
    }

    vue.mixin({
      created: function () {
        this.$vux = vue.$vux;
      }
    });
  }
};

export default plugin;
export const install = plugin.install;




// WEBPACK FOOTER //
// ./src/components/BGLoading/index.js